import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faLocationDot, faPhone, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    subject: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData(e.target);

    try {
      const response = await fetch("https://formsubmit.co/kaconstructionsolutions@gmail.com", {
        method: "POST",
        body: formDataToSend,
      });

      if (response.ok) {
        Swal.fire({
          title: "Success!",
          text: "Your message has been sent. We'll connect with you shortly. Thank you for reaching out!",
          icon: "success",
          confirmButtonColor: "#facc15",
        });

        // Reset form
        setFormData({
          name: "",
          phone: "",
          subject: "",
          email: "",
          message: "",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Sorry, something didn't work. Try again later or message us directly on WhatsApp Our Number are added.",
          icon: "error",
          confirmButtonColor: "#facc15",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Network Error!",
        text: "Unable to send message. Check your internet connection.",
        icon: "error",
        confirmButtonColor: "#facc15",
      });
    }
  };

  return (
    <div className="w-full">
      <div className="w-full h-[350px] border mb-10 header flex justify-center items-center">
        <div className="text-center mt-10" data-aos="zoom-in">
          <p className="text-3xl lg:text-5xl font-extrabold text-white mb-5 signature-dancing">Contact Us</p>
          <p className="text-lg text-white">Get in touch with us for any inquiries or bookings.</p>
        </div>
      </div>

      {/* Container */}
      <div className="max-w-7xl mx-auto px-4 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

          {/* LEFT SIDE CONTACT DETAILS */}
          <div className="space-y-10" data-aos="fade-right">
            <div>
              <h3 className="text-2xl font-semibold text-yellow-600 flex items-center gap-3">
                <span className="text-3xl"><FontAwesomeIcon icon={faUser} /></span> Contact Us:
              </h3>
              <p className="mt-3 text-black text-lg ms-4 hover:scale-110 hover:ms-10">
                <FontAwesomeIcon icon={faPhone} className="me-2 text-yellow-600" />
                <a href="tel:07796592487">07796 592 487</a>
              </p>
              <p className="text-black text-lg ms-4 hover:scale-110 hover:ms-10">
                <FontAwesomeIcon icon={faWhatsapp} className="me-2 text-yellow-600" />
                <a href="https://wa.me/447796592487" target="_blank"> 07796 592 487 </a>

              </p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-yellow-600 flex items-center gap-3">
                <span className="text-3xl"><FontAwesomeIcon icon={faEnvelope} /></span> Email:
              </h3>
              <p className="mt-3 text-black text-lg hover:scale-110 hover:ms-10"><a href="mailto:kaconstructionsolutions@gmail.com">Kaconstructionsolutions@gmail.com</a></p>
            </div>

            <div>
              <h3 className="text-2xl font-semibold text-yellow-600 flex items-center gap-3">
                <span className="text-3xl"><FontAwesomeIcon icon={faLocationDot} /></span> Address:
              </h3>
              <p className="mt-3 text-black text-lg hover:scale-110 hover:ms-10">
                <a href="https://www.google.com/maps/search/?api=1&query=19+Fenham+Road+Newcastle+Upon+Tyne+NE4+5PB"
                  target="_blank">
                  19 Fenham Road Newcastle Upon Tyne NE4 5PB
                </a>

              </p>
            </div>
          </div>

          {/* RIGHT SIDE FORM */}
          <form onSubmit={handleSubmit} className="space-y-6" data-aos="fade-left">

            {/* Hidden FormSubmit fields */}
            <input type="hidden" name="_subject" value="New Contact Form Submission!" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_captcha" value="false" />

            {/* Row 1 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                className="border border-yellow-600 p-3 rounded-md w-full focus:outline-none"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone No"
                className="border border-yellow-600 p-3 rounded-md w-full focus:outline-none"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                className="border border-yellow-600 p-3 rounded-md w-full focus:outline-none"
                value={formData.subject}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                className="border border-yellow-600 p-3 rounded-md w-full focus:outline-none"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Message */}
            <textarea
              rows="4"
              name="message"
              placeholder="Message"
              className="border border-yellow-600 p-3 rounded-md w-full focus:outline-none"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button
              type="submit"
              className="w-full bg-yellow-600 text-white py-3 rounded-md text-lg font-semibold hover:bg-yellow-700 transition duration-300"
            >
              SUBMIT
            </button>
          </form>

        </div>
      </div>

      {/* Google Map */}
      <div className="w-full h-[450px] mt-10">
        <iframe
          title="map"
          className="w-full h-full border-0"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2277.7326549518576!2d-1.640192!3d54.977515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487e773957788293%3A0x3e81034ed611c24!2s19%20Fenham%20Rd%2C%20Newcastle%20upon%20Tyne%20NE4%205PB%2C%20UK!5e0!3m2!1sen!2suk!4v1700000000000"
        />

      </div>
    </div>
  );
};

export default Contact;
